import { Modal, message } from 'antd';
import React, { Component } from 'react'
import FomeList from './FomeList';
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";

export default class RouteModal extends Component {
    state = {
        visible: false,
        params: {},
        routeList: [],
    }

    componentDidMount() {
        this.queryAdministrationRouteList()
    }

    queryAdministrationRouteList = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryAdministrationRouteList,
            data: { },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    routeList: res.datas,
                });
            }
        };
        $.sendRequest(options);
    }

    show = (params) => {
        const { routeIds } = params;
        const { routeList } = this.state;
        const routeIdArr = routeIds ? routeIds.split(',') : [];
        routeIdArr.map((el, index) => {
            params[`routeId${index + 1}`] = el;
            params[`routeType${index + 1}`] = routeList.find(item => item.evaluateAdministrationRouteId == el).routeType;
        })
        this.setState({
            visible: true,
            params: { 
                ...params,
            }
        })
    }

    hide = () => {
        this.setState({
            visible: false,
            params: {},
        })
    }

    submit = () => {
        const { handleTableChange } = this.props;
        const { params, routeList, params: { medicationNumber, index } } = this.state;
        const routeIdArr = [];
        const routeNameArr = [];
        try {
            for (let index = 1; index <= medicationNumber; index++) {
                if(!params[`routeId${index}`]) {
                    throw `给药途径${index}`
                }else {
                    routeIdArr.push(params[`routeId${index}`])
                    routeNameArr.push( `${routeList.find(el => el.evaluateAdministrationRouteId == params[`routeId${index}`]).routeName}(${params[`routeType${index}`]})` )
                }
            }
        } catch (error) {
            message.warning(`请填写${error}！`);
            return false
        }
        handleTableChange({
            routeIds: routeIdArr.join(','),
            routeNames: routeNameArr.join(','),
        }, 'routeId', index)
        this.hide()
    }

    handleChange = (value, key) => {
        const { params, routeList } = this.state;
        params[key] = value;
        params[key.replace(/routeId/g, "routeType")] = value ? routeList.find(el => el.evaluateAdministrationRouteId == value).routeType : '';
        this.setState({
            params: {
                ...params
            }
        })
    }

    render() {
        const { visible, params, routeList } = this.state;
        const { medicationNumber } = params;
        const routeOption = routeList.map(el => ({ label: el.routeName, value: el.evaluateAdministrationRouteId }));
        const Config = [];
        for (let index = 1; index <= medicationNumber; index++) {
            Config.push({
                label: `给药途径${index}`,
                name: `routeId${index}`,
                type: 'Select',
                required: true,
                typeProperty: {
                    option: routeOption,
                    style: { width: 185 }
                },
            },
            {
                label: `给药类别${index}`,
                name: `routeType${index}`,
                type: 'text',
            })
            
        }
        return (
            <Modal
            title={`给药途径`}
            visible={visible}
            onCancel={this.hide}
            onOk={this.submit}
            className="create-modal EditPersonModal"
            wrapClassName="vertical-center-modal"
            maskClosable={false}
            width={700}
        >
            <FomeList
                params={params}
                updateType="edit"
                handleChange={this.handleChange}
                DomConfig={Config}
            />
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/RouteModal.js